/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 4/27/15.
 */

function PackageMediaAdpodAssetSelectorController (
    this: JS5Object,
    _: JS5Object,
    AssetValidationService: JS5Object,
    DynamicPropertiesService: JS5Object,
    PackageFileUploadService: JS5Object,
    PackageMediaService: JS5Object,
    PackageUtilService: JS5Object,
    TempFileUploadService: JS5Object,
) {

    const setAdPod = (virtualPath: string, isRemoteUploadEnabled: boolean) => {
        this.adpodAsset.virtualPath = virtualPath;
        this.adpodAsset.assetId = -1;
        if (isRemoteUploadEnabled) {
            this.adpodAsset.pendingIngest = true;
        } else {
            delete this.adpodAsset.pendingIngest;
        }
        PackageUtilService.editorForm.$setDirty();
    };


    //================//
    // Template Logic //
    //================//

    this.remoteUploadEnabled = () => {
        return DynamicPropertiesService.getPropValueAsBoolean('mediaTabRemoteUpload.enabled', false);
    }

    this.getAcceptProfile = () => {
        return this.adpodAsset.adPodAcceptProfile;
    };

    this.onQualityControlButtonClick = ($event: JS5Object) => {
        $event.stopImmediatePropagation();
        PackageMediaService.openQualityControlModal(this.adpodAsset);
    };

    this.onCurrentFileChanged = () => {
        PackageFileUploadService.unregisterLocalConfig(this.uploaderConfig);
        setAdPod(null, false);
        if (_.get(this, 'currentFile.status') === 'PASSED') {
            switch (this.currentFile.type) {
                case 'ASPERA':
                    // TODO: Test in UI when Aspera is configured
                    setAdPod(this.currentFile.results[0].uploadedData, true);
                    break;
                case 'LOCAL':
                    // Display fileName (Correct virtualPath is set when media is saved)
                    PackageFileUploadService.registerLocalConfigForUpload(this.uploaderConfig);
                    setAdPod(`s3:fakePath/${this.currentFile.files[0].file.name}`, false);
                    break;
                case 'REMOTE':
                    setAdPod(this.currentFile.files[0].virtualPath, false);
                    break;
            }
        }
    };


    //========================//
    // Remote File Validation //
    //========================//

    this.validateRemoteFile = (fileSystemItem: JS5Object) => {
        let virtualPath = fileSystemItem.parent + fileSystemItem.name;
        return AssetValidationService.validateMediaRemote(virtualPath, this.getAcceptProfile().id);
    };


    //========================//
    // Aspera File Validation //
    //========================//

    this.validateAsperaFile = (asperaFileObject: JS5Object) => {
        return AssetValidationService.validateAdPodLocal(asperaFileObject.file, this.getAcceptProfile())
            .then((result: JS5Object) => {
                return PackageFileUploadService.parseAsperaValidationResult(PackageMediaService.packageObject, asperaFileObject, result);
            });
    };


    //=======================//
    // Local File Validation //
    //=======================//

    this.getLocalFilePreValidationErrors = (file: File, filter: JS5Object) => {
        // Doesn't add any local file filters
    };

    this.validateLocalFile = (fileItem: JS5Object, uploaderConfig: JS5Object) => {
        fileItem.onVirtualPathSet = (virtualPath: string) => {
            setAdPod(virtualPath, true);
        };
        return AssetValidationService.validateAdPodLocal(fileItem._file, this.getAcceptProfile());
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.initializeLocalUploaderConfig = (uploaderConfig: JS5Object) => {
        TempFileUploadService.initialize(uploaderConfig);
        this.uploaderConfig = uploaderConfig;
    };

    this.$onChanges = (changes: JS5Object) => {
        if (changes.adpodAsset && this.uploaderConfig) {
            this.currentFile = null;
        }
    };

    this.$onDestroy = () => {
        PackageFileUploadService.unregisterLocalConfig(this.uploaderConfig);
    };
}

angular.module('prism-ui.package').component('packageMediaAdpodAssetSelector', {
    controller: PackageMediaAdpodAssetSelectorController,
    templateUrl: 'package/editor/components/view/media/assetSelector/adPod/package-media-adpod-asset-selector-template.html',
    bindings: {
        adpodAsset: '<'
    }
});
